import { render, staticRenderFns } from "./BuisnessTypes.vue?vue&type=template&id=9470bb68&"
import script from "./BuisnessTypes.vue?vue&type=script&lang=js&"
export * from "./BuisnessTypes.vue?vue&type=script&lang=js&"
import style0 from "./BuisnessTypes.vue?vue&type=style&index=0&id=9470bb68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports